import RelatedDetail from '../../../related/_detail';

// Related site detail (EN). Copy and images: src/data/related/queens-butler.ts; FAQ: src/data/faq.json (/en/related/queens-butler).
export default function EnRelatedQueensButlerPage() {
  return <RelatedDetail slug="queens-butler" lang="en" />;
}
